import { render } from "./term_display.vue?vue&type=template&id=5ef6e784"
import script from "./term_display.vue?vue&type=script&lang=js"
export * from "./term_display.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__